import { render, staticRenderFns } from "./UserInvitationDataResources.vue?vue&type=template&id=16b84da1&scoped=true"
import script from "./UserInvitationDataResources.vue?vue&type=script&lang=ts"
export * from "./UserInvitationDataResources.vue?vue&type=script&lang=ts"
import style0 from "./UserInvitationDataResources.vue?vue&type=style&index=0&id=16b84da1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b84da1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b84da1')) {
      api.createRecord('16b84da1', component.options)
    } else {
      api.reload('16b84da1', component.options)
    }
    module.hot.accept("./UserInvitationDataResources.vue?vue&type=template&id=16b84da1&scoped=true", function () {
      api.rerender('16b84da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite/UserInvitationDataResources.vue"
export default component.exports